<template>
  <div class="nuttrema-filter-by-origin">
    <span class="nuttrema-filter-by-origin--label">
      <span v-if="collapsed"><i class="far fa-filter"></i></span>
      <span v-else>{{ $t('label.filter') }}</span>
    </span>
    <el-select
       size="small"
       v-model="selected.key"
       clearable
      :placeholder="$t('label.select_filter')"
      @change="handleFilterByOrigin">
      <template v-for="(group, key) in filters.list">
        <el-option
           v-if="group.type === 'option'"
          :key="group.key"
          :label="group.label"
          :value="group.key">
        </el-option>
        <el-option-group
           v-if="group.type === 'group'"
          :key="group.key"
          :label="group.label">
            <el-option
               v-for="option in group.options"
              :key="option.key"
              :label="option.label"
              :value="option.key">
            </el-option>
        </el-option-group>
      </template>
    </el-select>
  </div>
</template>

<script>
import { first } from 'lodash';

export default {
  name: 'nuttrema-filter-by-origin',
  props: {
    filters: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      selected: {
        key: null,
      },
    };
  },
  methods: {
    handleFilterByOrigin(origin) {
      this.$emit('filterByOrigin', origin);
    },
  },
  computed: {
    collapsed() {
      return this.$parent.collapsed || false;
    },
  },
  created() {
    const filter = first(this.filters.selected);
    if (filter) this.selected.key = filter.key;
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-filter-by-origin {
    display: flex;
    flex-shrink: 0;
    align-items: center;

    .nuttrema-filter-by-origin--label {
      padding-right: 0.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-filter-by-origin.vue